import { createSlice } from "@reduxjs/toolkit";
import lang from "../assets/lang/icons.json";

const initialState = {
  customTextColor: [
    {
      textColor: `${lang.staticTemp.textColor}`,
    },
  ],
  customNameColor: [
    {
      textName: `${lang.staticTemp.textName}`,
    },
  ],
  customThemeColor: [
    {
      themeColor: `${lang.staticTemp.themeColor}`,
    },
  ],
  iconsThemeDefault: [
    {
      iconsThemeDefault: false,
    },
  ],
  customLinkColor: [
    {
      linkColor: `${lang.staticTemp.linkColor}`,
    },
  ],
  customFontSize: [
    {
      fontSize: "1",
    },
  ],
  customFontFamily: [
    {
      fontFamily: "Arial",
    },
  ],
  imageSize: [
    {
      imageSize: `1`,
    },
  ],
  imageShape: [
    {
      imageShape: "square",
    },
  ],
  iconSize: [
    {
      iconSize: "1",
    },
  ],
};

export const styleSlice = createSlice({
  name: "style",
  initialState,
  reducers: {
    customTextColor: (state, action) => {
      if (Object.values(action.payload).every((el) => el === "")) {
        state.customTextColor = [];
        state.customTextColor = [
          ...state.customTextColor,
          initialState.customTextColor[0],
        ];
      } else {
        const textColor = action.payload;
        state.customTextColor = [];
        state.customTextColor = [...state.customTextColor, { textColor }];
      }
    },

    customThemeColor: (state, action) => {
      if (Object.values(action.payload).every((el) => el === "")) {
        state.customThemeColor = [];
        state.customThemeColor = [
          ...state.customThemeColor,
          initialState.customThemeColor[0],
        ];
      } else {
        const themeColor = action.payload;
        state.customThemeColor = [];
        state.customThemeColor = [...state.customThemeColor, { themeColor }];
      }
    },
    iconsThemeDefault: (state, action) => {
      if (action.payload === "") {
        state.iconsThemeDefault = [];
        state.iconsThemeDefault = [
          ...state.iconsThemeDefault,
          initialState.iconsThemeDefault[0],
        ];
      } else {
        const iconsThemeDefault = action.payload;
        state.iconsThemeDefault = [];
        state.iconsThemeDefault = [
          ...state.iconsThemeDefault,
          { iconsThemeDefault },
        ];
      }
    },

    customLinkColor: (state, action) => {
      if (Object.values(action.payload).every((el) => el === "")) {
        state.customLinkColor = [];
        state.customLinkColor = [
          ...state.customLinkColor,
          initialState.customLinkColor[0],
        ];
      } else {
        const linkColor = action.payload;
        state.customLinkColor = [];
        state.customLinkColor = [...state.customLinkColor, { linkColor }];
      }
    },

    customFontFamily: (state, action) => {
      const fontFamily = action.payload;
      state.customFontFamily = [];
      state.customFontFamily = [...state.customFontFamily, { fontFamily }];
    },

    customFontSize: (state, action) => {
      if (action.payload === "") {
        state.customFontSize = [];
        state.customFontSize = [
          ...state.customFontSize,
          initialState.customFontSize[0],
        ];
      } else {
        const fontSize = action.payload;
        state.customFontSize = [];
        state.customFontSize = [...state.customFontSize, { fontSize }];
      }
    },
    customNameColor: (state, action) => {
      if (action.payload === "") {
        state.customNameColor = [];
        state.customNameColor = [
          ...state.customNameColor,
          initialState.customNameColor[0],
        ];
      } else {
        const textName = action.payload;
        state.customNameColor = [];
        state.customNameColor = [...state.customNameColor, { textName }];
      }
    },

    imageSize: (state, action) => {
      if (action.payload === "") {
        state.imageSize = [];
        state.imageSize = [...state.imageSize, initialState.imageSize[0]];
      } else {
        const imageSize = action.payload;
        state.imageSize = [];
        state.imageSize = [...state.imageSize, { imageSize }];
      }
    },

    imageShape: (state, action) => {
      if (action.payload === "") {
        state.imageShape = [];
        state.imageShape = [...state.imageShape, initialState.imageShape[0]];
      } else {
        const imageShape = action.payload;
        state.imageShape = [];
        state.imageShape = [...state.imageShape, { imageShape }];
      }
    },

    iconSize: (state, action) => {
      if (action.payload === "") {
        state.iconSize = [];
        state.iconSize = [...state.iconSize, initialState.iconSize[0]];
      } else {
        const iconSize = action.payload;
        state.iconSize = [];
        state.iconSize = [...state.iconSize, { iconSize }];
      }
    },

    resetStyle: (state, action) => {
      if (action.payload === true) {
        state.customNameColor = [];
        state.customNameColor = [
          ...state.customNameColor,
          initialState.customNameColor[0],
        ];

        state.customFontSize = [];
        state.customFontSize = [
          ...state.customFontSize,
          initialState.customFontSize[0],
        ];

        state.customLinkColor = [];
        state.customLinkColor = [
          ...state.customLinkColor,
          initialState.customLinkColor[0],
        ];

        state.customThemeColor = [];
        state.customThemeColor = [
          ...state.customThemeColor,
          initialState.customThemeColor[0],
        ];

        state.iconsThemeDefault = [];
        state.iconsThemeDefault = [
          ...state.iconsThemeDefault,
          initialState.iconsThemeDefault[0],
        ];

        state.customTextColor = [];
        state.customTextColor = [
          ...state.customTextColor,
          initialState.customTextColor[0],
        ];

        state.customFontFamily = [];
        state.customFontFamily = [
          ...state.customFontFamily,
          initialState.customFontFamily[0],
        ];

        state.imageShape = [];
        state.imageShape = [...state.imageShape, initialState.imageShape[0]];

        state.imageSize = [];
        state.imageSize = [...state.imageSize, initialState.imageSize[0]];

        state.iconSize = [];
        state.iconSize = [...state.iconSize, initialState.iconSize[0]];
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  customTextColor,
  customThemeColor,
  iconsThemeDefault,
  customLinkColor,
  customFontSize,
  customFontFamily,
  customNameColor,
  imageSize,
  imageShape,
  iconSize,
  resetStyle,
} = styleSlice.actions;

export default styleSlice.reducer;
